// @ts-nocheck
import { ProjectAction, ProjectActions, ProjectState } from '../../types/project';
import { PhaseSortTypes } from '../../models/SortTypes';
import { ICard } from '../../components/kanbanBoard/models/BoardModel';
import { IProjectTaskModel } from '../../models/ProjectTaskModel';
import { sortTasks } from '../../helpers/TasksHelper';
import { createBoardFromProject, sortProjectTasks } from '../../helpers/ProjectHelper';
import localStorageService, { LocalStorageKeys } from '../../../../../services/localStorageService';
import { FrontendVisibility } from '../../models/ISettingsFrontend';

const initialState: ProjectState = {
  projects: [],
  board: null,
  project: null,
  developers: [],
  currentProjectReleaseId: null,
  currentSortingType:
    localStorageService.get(LocalStorageKeys.CachedSortType) ?? PhaseSortTypes.Default,
  loading: false,
  releaseDropdown: [],
  phaseDropdown: [],
  errors: null,
};

export const projectReducer = (state = initialState, action: ProjectAction): ProjectState => {
  switch (action.type) {
    case ProjectActions.FETCH_CURRENT_PROJECTS:
      return {
        ...state,
        loading: true,
        errors: { ...state.errors, currentProjects: null },
        projects: [],
      };
    case ProjectActions.FETCH_CURRENT_PROJECTS_SUCCESS:
      const error = action.payload.length <= 0 ? 'You have no assigned projects yet.' : null;
      return {
        ...state,
        loading: false,
        errors: { ...state.errors, currentProjects: error },
        projects: action.payload,
      };
    case ProjectActions.FETCH_CURRENT_PROJECTS_SILENT_SUCCESS:
      return {
        ...state,
        errors: {
          ...state.errors,
          currentProjects: action.payload.length <= 0 ? 'You have no assigned projects yet.' : null,
        },
        projects: action.payload,
      };
    case ProjectActions.FETCH_CURRENT_PROJECTS_ERROR:
      return {
        ...state,
        loading: false,
        errors: { ...state.errors, currentProjects: action.payload },
        projects: [],
      };
    case ProjectActions.FETCH_CURRENT_PROJECTS_SILENT_ERROR:
      return {
        ...state,
        errors: { ...state.errors, currentProjects: action.payload },
      };

    case ProjectActions.FETCH_PROJECT:
      return { ...state, loading: true, errors: { ...state.errors, project: null }, project: null };
    case ProjectActions.FETCH_PROJECT_SUCCESS:
      return {
        ...state,
        loading: false,
        errors: { ...state.errors, project: null },
        project: action.payload,
      };
    case ProjectActions.FETCH_PROJECT_ERROR:
      return {
        ...state,
        loading: false,
        errors: { ...state.errors, project: action.payload },
        project: null,
      };

    case ProjectActions.FETCH_PROJECT_PHASES:
      return { ...state, loading: true, errors: { ...state.errors, projectPhases: null } };
    case ProjectActions.FETCH_PROJECT_PHASES_SUCCESS: {
      const project = { ...state.project };
      project.projectPhases = action.payload;
      const sortingType = state.currentSortingType;
      if (sortingType) {
        sortProjectTasks(project, sortingType);
      }
      const board = createBoardFromProject(project);
      return { ...state, project, board, loading: false };
    }
    case ProjectActions.SET_PROJECT_LOADER:
      return {
        ...state,
        loading: action.payload,
        errors: { ...state.errors, projectPhases: null },
      };
    case ProjectActions.FETCH_PROJECT_ARCHIVE_PHASE:
      return {
        ...state,
        loading: true,
        errors: { ...state.errors, projectPhases: null, projectArchivePhases: null },
      };
    case ProjectActions.FETCH_PROJECT_ARCHIVE_PHASE_SUCCESS: {
      const adjusIfNotArchiveTaskProjectPhase = state.project?.projectArchivePhases?.length
        ? [...state.project.projectPhases]
        : [
            ...state.project.projectPhases,
            ...(state.project?.projectArchivePhases || action.payload || []),
          ];

      const project = {
        ...state.project,
        projectPhases: adjusIfNotArchiveTaskProjectPhase,
        projectArchivePhases: [...action.payload],
      };
      const sortingType = state.currentSortingType;
      if (sortingType) {
        sortProjectTasks(project, sortingType);
      }
      const board = createBoardFromProject(project);
      return { ...state, project, board, loading: false };
    }
    case ProjectActions.FETCH_PROJECT_ARCHIVE_PHASE_ERROR:
      return {
        ...state,
        loading: false,
        errors: { ...state.errors, projectArchivePhases: action.payload },
      };
    case ProjectActions.SET_PROJECT_ARCHIVE_PHASE: {
      const updatedProjectArchivePhases = [
        ...state.project.projectPhases.filter((phase) => phase.superPhaseName !== 'ARCHIVE'),
        ...(state.project.projectArchivePhases || []),
      ];

      const project = {
        ...state.project,
        projectPhases: updatedProjectArchivePhases,
      };
      const sortingType = state.currentSortingType;
      if (sortingType) {
        sortProjectTasks(project, sortingType);
      }
      const board = createBoardFromProject(project);
      return { ...state, project, board };
    }
    case ProjectActions.REMOVE_PROJECT_ARCHIVE_PHASE: {
      const updatedProjectPhases = state.project.projectPhases.filter(
        (phase) => phase.superPhaseName !== 'ARCHIVE'
      );

      const project = {
        ...state.project,
        projectPhases: updatedProjectPhases,
      };
      const sortingType = state.currentSortingType;
      if (sortingType) {
        sortProjectTasks(project, sortingType);
      }
      const board = createBoardFromProject(project);
      return { ...state, project, board };
    }
    case ProjectActions.FETCH_PROJECT_PHASES_ERROR:
      return {
        ...state,
        loading: false,
        errors: { ...state.errors, projectPhases: action.payload },
      };

    case ProjectActions.FETCH_DEVELOPERS:
      return {
        ...state,
        loading: true,
        errors: { ...state.errors, developers: null },
        developers: [],
      };
    case ProjectActions.FETCH_DEVELOPERS_SUCCESS:
      return {
        ...state,
        loading: false,
        errors: { ...state.errors, developers: null },
        developers: action.payload,
      };
    case ProjectActions.FETCH_DEVELOPERS_ERROR:
      return {
        ...state,
        loading: false,
        errors: { ...state.errors, developers: action.payload },
        developers: [],
      };

    case ProjectActions.CHANGE_TASK_PHASE:
      return { ...state, errors: { ...state.errors, taskPhase: null } };
    case ProjectActions.CHANGE_TASK_PHASE_SUCCESS: {
      const project = { ...state.project };
      project.projectPhases = [...state.project.projectPhases];

      const phaseIndex = project.projectPhases.findIndex(
        (phase) => phase.id === action.payload.taskPhaseId
      );

      if (phaseIndex !== -1) {
        const phase = { ...project.projectPhases[phaseIndex] };
        phase.phaseTasks = [...phase.phaseTasks];

        const taskIndex = phase.phaseTasks.findIndex((task) => task.id === action.payload.id);

        if (taskIndex !== -1) {
          const releaseTimeFields = [
            'taskEstimateTimeInRelease',
            'taskSpentTimeInRelease',
            'taskRemainingTimeInRelease',
          ] as const;

          const currentTask = phase.phaseTasks[taskIndex];
          const updatedTask = { ...currentTask, ...action.payload };

          releaseTimeFields.forEach((field) => {
            const serverValue = action.payload[field];
            const previousValue = currentTask[field];

            if (
              (serverValue === null || serverValue === undefined) &&
              previousValue !== null &&
              previousValue !== undefined
            ) {
              updatedTask[field] = previousValue;
            }
          });

          phase.phaseTasks[taskIndex] = updatedTask;
        }

        project.projectPhases[phaseIndex] = phase;
      }

      const board = createBoardFromProject(project);

      return {
        ...state,
        project,
        board,
        errors: { ...state.errors, taskPhase: null },
      };
    }
    case ProjectActions.CHANGE_TASK_PHASE_ERROR:
      return { ...state, errors: { ...state.errors, taskPhase: action.payload } };

    case ProjectActions.RESTORE_TASK_PHASE_MOVE:
      return {
        ...state,
        project: action.payload.project,
        board: action.payload.board,
      };

    case ProjectActions.CHANGE_PROJECT_PHASE_ORDER:
      return { ...state, errors: { ...state.errors, phaseOrder: null } };
    case ProjectActions.CHANGE_PROJECT_PHASE_ORDER_ERROR:
      return { ...state, errors: { ...state.errors, phaseOrder: action.payload } };

    case ProjectActions.DRAG_HAPPEND: {
      const project = { ...state.project };
      const phaseList = project.projectPhases.find(
        (list) => list.id === Number(action.payload.droppableIdStart)
      );
      const card = phaseList.phaseTasks.splice(action.payload.droppableIndexStart, 1);
      phaseList.phaseTasks.splice(action.payload.droppableIndexEnd, 0, ...card);

      return { ...state, project };
    }

    case ProjectActions.DRAG_LIST_HAPPEND: {
      const project = {
        ...state.project,
        projectPhases: [...state.project.projectPhases],
      };
      const phaseList = project.projectPhases.splice(action.payload.indexStart, 1);
      project.projectPhases.splice(action.payload.indexEnd, 0, ...phaseList);

      const board = {
        ...state.board,
        lanes: [...state.board.lanes],
      };
      const lanes = board.lanes.splice(action.payload.indexStart, 1);
      board.lanes.splice(action.payload.indexEnd, 0, ...lanes);

      return { ...state, project, board };
    }

    case ProjectActions.UPDATE_TASK_PHASE: {
      const project = { ...state.project };
      project.projectPhases = [...state.project.projectPhases];

      const {
        droppableIndexStart,
        droppableIndexEnd,
        droppableIdStart,
        droppableIdEnd,
        sortingType,
      } = action.payload;

      if (droppableIdStart !== droppableIdEnd) {
        const sourcePhaseIndex = project.projectPhases.findIndex(
          (phase) => phase.id === Number(droppableIdStart)
        );
        const destinationPhaseIndex = project.projectPhases.findIndex(
          (phase) => phase.id === Number(droppableIdEnd)
        );

        const sourcePhase = { ...project.projectPhases[sourcePhaseIndex] };
        sourcePhase.phaseTasks = [...sourcePhase.phaseTasks];

        const destPhase = { ...project.projectPhases[destinationPhaseIndex] };
        destPhase.phaseTasks = [...destPhase.phaseTasks];

        const [deletedTask] = sourcePhase.phaseTasks.splice(droppableIndexStart, 1);
        destPhase.phaseTasks.splice(droppableIndexEnd, 0, deletedTask);

        if (sortingType) {
          sortTasks(destPhase.phaseTasks, sortingType);
        }

        project.projectPhases[sourcePhaseIndex] = sourcePhase;
        project.projectPhases[destinationPhaseIndex] = destPhase;
      } else if (droppableIndexStart !== droppableIndexEnd) {
        const phaseIndex = project.projectPhases.findIndex(
          (phase) => phase.id === Number(droppableIdStart)
        );

        const targetPhase = { ...project.projectPhases[phaseIndex] };
        targetPhase.phaseTasks = [...targetPhase.phaseTasks];

        const newTask = targetPhase.phaseTasks[droppableIndexStart];
        const oldTask = targetPhase.phaseTasks[droppableIndexEnd];

        if (
          sortingType === PhaseSortTypes.Newest ||
          (sortingType === PhaseSortTypes.Priority && oldTask?.priorityId !== newTask?.priorityId)
        ) {
          return { ...state, project };
        }

        const [deletedTask] = targetPhase.phaseTasks.splice(droppableIndexStart, 1);
        targetPhase.phaseTasks.splice(droppableIndexEnd, 0, deletedTask);

        project.projectPhases[phaseIndex] = targetPhase;
      }

      return {
        ...state,
        project,
        board: createBoardFromProject(project),
      };
    }

    case ProjectActions.CHANGE_TASK_DURATION_AND_PRIORITY: {
      return { ...state, errors: { ...state.errors, changeTaskDurationAndPriority: null } };
    }
    case ProjectActions.CHANGE_TASK_DURATION_AND_PRIORITY_SUCCESS: {
      const project = { ...state.project };
      const task = project.projectPhases
        .find((list) => list.id === Number(action.payload.taskPhaseId))
        .phaseTasks.find((task) => task.id === action.payload.id);
      Object.assign(task, action.payload);

      return { ...state, project };
    }
    case ProjectActions.CHANGE_TASK_DURATION_AND_PRIORITY_ERROR:
      return {
        ...state,
        errors: { ...state.errors, changeTaskDurationAndPriority: action.payload },
      };

    case ProjectActions.CREATE_MULTIPLE_TASKS:
      return { ...state, errors: { ...state.errors, createMultipleTasks: null } };
    case ProjectActions.CREATE_MULTIPLE_TASKS_SUCCESS: {
      const project = { ...state.project };
      const board = { ...state.board };
      const phaseTasks = project.projectPhases.find(
        (list) => list.id === Number(action.payload[0].taskPhaseId)
      ).phaseTasks;
      const laneCards = board.lanes.find(
        (lane) => lane.id === action.payload[0].taskPhaseId.toString()
      ).cards;
      const newCards = action.payload.map(
        (ticket) =>
          ({
            id: ticket.id,
            content: ticket,
          }) as ICard<IProjectTaskModel>
      );

      phaseTasks.push(...action.payload);
      laneCards.push(...newCards);

      return { ...state, project, board };
    }
    case ProjectActions.CREATE_MULTIPLE_TASKS_ERROR:
      return { ...state, errors: { ...state.errors, createMultipleTasks: action.payload } };

    case ProjectActions.CREATE_PROJECT_PHASE:
      return { ...state, errors: { ...state.errors, createProjectPhase: null } };
    case ProjectActions.CREATE_PROJECT_PHASE_SUCCESS: {
      const project = { ...state.project };
      const board = { ...state.board };

      const newPhase = action.payload;
      const newLane = {
        id: newPhase.id.toString(),
        title: newPhase.phaseName,
        label: newPhase.id.toString(),
        cards: new Array<ICard<IProjectTaskModel>>(),
      };

      const phaseWithVisibility = {
        ...newPhase,
        settingsFrontend: newPhase.settingsFrontend ?? {
          Visibility: FrontendVisibility.Open,
        },
      };
      project.projectPhases = [...project.projectPhases, phaseWithVisibility];
      board.lanes = [...board.lanes, newLane];

      return { ...state, project, board };
    }
    case ProjectActions.CREATE_PROJECT_PHASE_ERROR:
      return { ...state, errors: { ...state.errors, createProjectPhase: action.payload } };

    case ProjectActions.RENAME_PHASE:
      return { ...state, errors: { ...state.errors, renamePhase: null } };
    case ProjectActions.RENAME_PHASE_SUCCESS: {
      const project = { ...state.project };
      const board = { ...state.board };

      const { id, value } = action.payload;

      const phase = project.projectPhases.find((phase) => phase.id === id);
      phase.phaseName = value;

      const lane = board.lanes.find((lane) => lane.id === String(id));
      lane.title = value;

      return { ...state, project, board };
    }

    case ProjectActions.ERROR:
      return { ...state, errors: { ...state.errors, error: action.payload } };

    case ProjectActions.SET_BOARD_SORTING_TYPE: {
      const { sortingType } = action.payload;

      const project = { ...state.project };

      if (sortingType) {
        sortProjectTasks(project, sortingType);
      } else {
        sortProjectTasks(project, PhaseSortTypes.Default);
      }

      const board = createBoardFromProject(project);

      return { ...state, board, project, currentSortingType: sortingType };
    }

    case ProjectActions.SET_CURRENT_PROJECT_RELEASE: {
      const { projectReleaseId } = action.payload;
      return { ...state, currentProjectReleaseId: projectReleaseId };
    }

    case ProjectActions.ARCHIVE_ALL_PHASE_TASKS:
      return { ...state, errors: { ...state.errors, archiveAllPhaseTasks: null } };
    case ProjectActions.ARCHIVE_ALL_PHASE_TASKS_SUCCESS: {
      const { phaseId } = action.payload;

      const project = { ...state.project };
      const board = { ...state.board };

      const phase = project.projectPhases.find((phase) => phase.id === Number(phaseId));
      phase.phaseTasks = [];

      const lane = board.lanes.find((lane) => lane.id === phaseId);
      lane.cards = [];

      return { ...state, project, board };
    }
    case ProjectActions.ARCHIVE_ALL_PHASE_TASKS_ERROR:
      return { ...state, errors: { ...state.errors, archiveAllPhaseTasks: action.payload } };

    case ProjectActions.GET_RELEASES_ALL_PHASE_TASKS:
      return { ...state, errors: { ...state.errors, getReleasesAllPhaseTasks: null } };
    case ProjectActions.GET_RELEASES_ALL_PHASE_TASKS_SUCCESS: {
      return {
        ...state,
        loading: false,
        errors: { ...state.errors, getReleasesAllPhaseTasks: null },
        releaseDropdown: action.payload,
      };
    }
    case ProjectActions.GET_RELEASES_ALL_PHASE_TASKS_ERROR:
      return { ...state, errors: { ...state.errors, getReleasesAllPhaseTasks: action.payload } };

    case ProjectActions.MOVE_TO_RELEASE_ALL_PHASE_TASKS:
      return { ...state, errors: { ...state.errors, moveToReleaseAllPhaseTasks: null } };
    case ProjectActions.MOVE_TO_RELEASE_ALL_PHASE_TASKS_SUCCESS: {
      const project = { ...state.project };
      const board = { ...state.board };
      try {
        const { phaseId, projectReleaseIdNew, projectReleaseIdCurrent } = action.payload;

        if (projectReleaseIdCurrent && projectReleaseIdCurrent != projectReleaseIdNew) {
          const phase = project.projectPhases.find((phase) => phase.id === Number(phaseId));
          phase.phaseTasks = [];
          const lane = board.lanes.find((lane) => lane.id === phaseId);
          lane.cards = [];
        }
      } catch (error) {
        console.error('===========An error occurred:', error);
      }
      return { ...state, project, board };
    }

    case ProjectActions.GET_PHASES_ALL_PHASE_TASKS:
      return { ...state, errors: { ...state.errors, getPhasesAllPhaseTasks: null } };
    case ProjectActions.GET_PHASES_ALL_PHASE_TASKS_SUCCESS: {
      return {
        ...state,
        loading: false,
        errors: { ...state.errors, getPhasesAllPhaseTasks: null },
        phaseDropdown: action.payload,
      };
    }
    case ProjectActions.GET_PHASES_ALL_PHASE_TASKS_ERROR:
      return { ...state, errors: { ...state.errors, getPhasesAllPhaseTasks: action.payload } };

    case ProjectActions.MOVE_TO_PHASE_ALL_PHASE_TASKS:
      return { ...state, errors: { ...state.errors, moveToPhaseAllPhaseTasks: null } };
    case ProjectActions.MOVE_TO_PHASE_ALL_PHASE_TASKS_SUCCESS: {
      const project = { ...state.project };
      const board = { ...state.board };
      try {
        const { phaseIdNew, phaseIdCurrent } = action.payload;

        if (phaseIdCurrent && phaseIdCurrent != phaseIdNew) {
          const currentPhase = project.projectPhases.find(
            (phase) => phase.id === Number(phaseIdCurrent)
          );
          const newPhase = project.projectPhases.find((phase) => phase.id === Number(phaseIdNew));

          newPhase.phaseTasks = newPhase.phaseTasks.concat(currentPhase.phaseTasks);
          currentPhase.phaseTasks = [];

          const currentlane = board.lanes.find((lane) => lane.id === phaseIdCurrent);
          const newlane = board.lanes.find((lane) => lane.id == phaseIdNew);

          newlane.cards = newlane.cards.concat(currentlane.cards);
          currentlane.cards = [];
        }
      } catch (error) {
        console.error('===========An error occurred:', error);
      }
      return { ...state, project, board };
    }
    case ProjectActions.MOVE_TO_PHASE_ALL_PHASE_TASKS_ERROR:
      return { ...state, errors: { ...state.errors, moveToPhaseAllPhaseTasks: action.payload } };

    case ProjectActions.DELETE_PHASE:
      return { ...state, errors: { ...state.errors, deletePhase: null } };
    case ProjectActions.DELETE_PHASE_SUCCESS: {
      const project = { ...state.project };
      const board = { ...state.board };
      const { phaseId } = action.payload;
      const updatedProjectPhases = project.projectPhases.filter((phase) => phase.id !== phaseId);
      const updatedBoardLanes = board.lanes.filter((lane) => lane.id !== phaseId.toString());
      const updatedProject = { ...project, projectPhases: updatedProjectPhases };
      const updatedBoard = { ...board, lanes: updatedBoardLanes };
      return { ...state, project: updatedProject, board: updatedBoard };
    }
    case ProjectActions.DELETE_PHASE_ERROR:
      return { ...state, errors: { ...state.errors, deletePhase: action.payload } };

    case ProjectActions.CHANGE_VISIBILITY_OF_LANE_PHASE:
      return { ...state, errors: { ...state.errors, changeVisibilityOfLanePhase: null } };
    case ProjectActions.CHANGE_VISIBILITY_OF_LANE_PHASE_SUCCESS: {
      const updateProject = { ...state.project };
      const updateVisibility = (phase) => {
        if (phase.id != action.payload.phaseId) return phase;

        return {
          ...phase,
          settingsFrontend: {
            ...phase.settingsFrontend,
            Visibility: action.payload.visibility,
          },
        };
      };
      const updateProjectPhases = updateProject.projectPhases.map((item) => {
        return updateVisibility(item);
      });
      updateProject.projectPhases = updateProjectPhases;
      if (updateProject.projectArchivePhases) {
        updateProject.projectArchivePhases =
          updateProject.projectArchivePhases.map(updateVisibility);
      }
      return { ...state, project: updateProject };
    }
    case ProjectActions.CHANGE_VISIBILITY_OF_LANE_PHASE_ERROR:
      return { ...state, errors: { ...state.errors, changeVisibilityOfLanePhase: action.payload } };
    default:
      return state;
  }
};
